<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<p class="tx52" id="p0019-01-0">
<a id="page19">
<b>69 </b>
<span class="st1">Demand excellence and be willing to pay for it.</span>
</a></p><a id="page19">
<p class="tx52" id="p0019-01-1">
<b>70 </b>
<span class="st1">Whistle.</span>
</p>
<p class="tx52" id="p0019-01-2">
<b>71 </b>
<span class="st1">Hug children after you discipline them.</span>
</p>
<p class="tx52" id="p0019-01-3">
<b>72 </b>
<span class="st1">Give to charity all the clothes you haven’t worn during the past three years.</span>
</p>
<p class="tx52" id="p0019-01-4">
<b>73 </b>
<span class="st1">Never forget your anniversary.</span>
</p>
<p class="tx52" id="p0019-01-5">
<b>74 </b>
<span class="st1">Eat prunes.</span>
</p>
<p class="tx52" id="p0019-01-6">
<b>75 </b>
<span class="st1">Ride a bike.</span>
</p>
<p class="tx52" id="p0019-01-7">
<b>76 </b>
<span class="st1">Choose a charity in your community and support it generously with your time and money.</span>
</p>
</a><p class="tx52" id="p0020-P-1"><a id="page19">
</a><a id="page20">
<b>77 </b>
<span class="st1">Slow dance.</span>
</a></p><a id="page20">
<p class="tx52" id="p0020-01-1">
<b>78 </b>
<span class="st1">Steer clear of restaurants with strolling musicians.</span>
</p>
<p class="tx52" id="p0020-01-2">
<b>79 </b>
<span class="st1">Don’t take good health for granted.</span>
</p>
<p class="tx52" id="p0020-01-3">
<b>80 </b>
<span class="st1">When someone wants to hire you, even if it’s for a job you have little interest in, talk to them. Never close the door on an opportunity until you’ve had a chance to hear the offer in person.</span>
</p>
<p class="tx52" id="p0020-01-4">
<b>81 </b>
<span class="st1">Don’t mess with drugs, and don’t associate with those who do.</span>
</p>
<p class="tx52" id="p0020-01-5">
<b>82 </b>
<span class="st1">Avoid sarcastic remarks.</span>
</p>
</a><p class="tx52" id="p0021-01-0"><a id="page20">
</a><a id="page21">
<b>83 </b>
<span class="st1">In business and in family relationships, remember that the most important thing is trust.</span>
</a></p><a id="page21">
<p class="tx52" id="p0021-01-1">
<b>84 </b>
<span class="st1">Forget the Joneses.</span>
</p>
<p class="tx52" id="p0021-01-2">
<b>85 </b>
<span class="st1">Never encourage anyone to become a lawyer.</span>
</p>
<p class="tx52" id="p0021-01-3">
<b>86 </b>
<span class="st1">Don’t smoke.</span>
</p>
<p class="tx52" id="p0021-01-4">
<b>87 </b>
<span class="st1">Even if you’re financially well-to-do, have your children earn and pay part of their college tuition.</span>
</p>
<p class="tx52" id="p0021-01-5">
<b>88 </b>
<span class="st1">Even if you’re financially well-to-do, have your children earn and pay for <em>all </em>their automobile insurance.</span>
</p>
</a><p class="tx52" id="p0022-P-1"><a id="page21">
</a><a id="page22">
<b>89 </b>
<span class="st1">Recycle old newspapers, bottles, and cans.</span>
</a></p><a id="page22">
<p class="tx52" id="p0022-01-1">
<b>90 </b>
<span class="st1">Refill ice cube trays.</span>
</p>
<p class="tx52" id="p0022-01-2">
<b>91 </b>
<span class="st1">Never invest more in the stock market than you can afford to lose.</span>
</p>
<p class="tx52" id="p0022-01-3">
<b>92 </b>
<span class="st1">Choose your life’s mate carefully. From this one decision will come ninety percent of all your happiness or misery.</span>
</p>
<p class="tx52" id="p0022-01-5">
<b>93 </b>
<span class="st1">Make it a habit to do nice things for people who’ll never find it out.</span>
</p>
<p class="tx52" id="p0022-01-6">
<b>94 </b>
<span class="st1">Lend only those books you never care to see again.</span>
</p>
</a><p class="tx52" id="p0023-01-0"><a id="page22">
</a><a id="page23">
<b>95 </b>
<span class="st1">Don’t let anyone ever see you tipsy.</span>
</a></p><a id="page23">
<p class="tx52" id="p0023-P-1">
<b>96 </b>
<span class="st1">Attend class reunions.</span>
</p>
<p class="tx52" id="p0023-01-1">
<b>97 </b>
<span class="st1">Always have something beautiful in sight, even if it’s just a daisy in a jelly glass.</span>
</p>
<p class="tx52" id="p0023-01-2">
<b>98 </b>
<span class="st1">Know how to type.</span>
</p>
<p class="tx52" id="p0023-01-3">
<b>99 </b>
<span class="st1">Read the Bill of Rights.</span>
</p>
<p class="tx53" id="p0023-01-4">
<b>100 </b>
<span class="st1">Learn how to read a financial report.</span>
</p>
<p class="tx53" id="p0023-01-5">
<b>101 </b>
<span class="st1">Tell your kids often how terrific they are and that you trust them.</span>
</p>
<p class="tx53" id="p0023-01-6">
<b>102 </b>
<span class="st1">Take a brisk thirty-minute walk every day.</span>
</p>
</a></section><a id="page23">
</a></div>
<a id="page23">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter8.vue?ac0edb2a